import { IconNames } from '@blueprintjs/icons';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';

import {
    BasePayerRequestNotification,
    type CommonPayerRequestNotificationProps,
} from 'components/notifications/BasePayerRequestNotification';

export interface PayerRequestAssignedNotificationProps extends CommonPayerRequestNotificationProps {
    small: boolean;
}

export const PayerRequestAssignedNotification = ({
    linkingId,
    timestamp,
    additionalData,
    onNotificationClick,
    onRemoveNotificationClick,
    status,
    small,
    payerId,
}: PayerRequestAssignedNotificationProps) => (
    <BasePayerRequestNotification
        notificationTitle="You Have Been Assigned A Request"
        icon={IconNames.USER}
        additionalDataComponent={
            <div className="flex__gap--small" style={{ flexDirection: 'column' }}>
                {!small && (
                    <DetailLabelValuePair
                        label="Request #"
                        value={additionalData.requestNumber?.toString().padStart(6, '0')}
                    />
                )}
            </div>
        }
        additionalData={additionalData}
        linkingId={linkingId}
        onNotificationClick={onNotificationClick}
        onRemoveNotificationClick={onRemoveNotificationClick}
        payerId={payerId}
        status={status}
        timestamp={timestamp}
    />
);
